import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-landing',
  templateUrl: './mobile-landing.component.html',
  styleUrls: ['./mobile-landing.component.css']
})
export class MobileLandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
